import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'angularx-qrcode';

function MobilePassModalComponent_qrcode_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "qrcode", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("qrdata", ctx_r0.url)("size", 256)("level", "M")("usesvg", true);
} }
class MobilePassModalComponent {
    constructor() { }
    ngOnInit() {
    }
}
MobilePassModalComponent.ɵfac = function MobilePassModalComponent_Factory(t) { return new (t || MobilePassModalComponent)(); };
MobilePassModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MobilePassModalComponent, selectors: [["fgbcl-mobile-pass-modal"]], inputs: { url: "url" }, decls: 7, vars: 1, consts: [[1, "card"], [1, "card-body"], [3, "qrdata", "size", "level", "usesvg", 4, "ngIf"], [3, "qrdata", "size", "level", "usesvg"]], template: function MobilePassModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h3");
        ɵngcc0.ɵɵtext(3, "Download Mobile Pass");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "p");
        ɵngcc0.ɵɵtext(5, "Please scan the QR code using your phone to download your pass");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, MobilePassModalComponent_qrcode_6_Template, 1, 4, "qrcode", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.url);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.QRCodeComponent], styles: [""] });
MobilePassModalComponent.ctorParameters = () => [];
MobilePassModalComponent.propDecorators = {
    url: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MobilePassModalComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-mobile-pass-modal',
                template: "<div class=\"card\">\r\n  <div class=\"card-body\">\r\n    <h3>Download Mobile Pass</h3>\r\n    <p>Please scan the QR code using your phone to download your pass</p>\r\n    <qrcode\r\n      *ngIf=\"url\"\r\n      [qrdata]=\"url\"\r\n      [size]=\"256\"\r\n      [level]=\"'M'\"\r\n      [usesvg]=\"true\"\r\n    ></qrcode>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { url: [{
            type: Input
        }] }); })();

class MobilePassModalModule {
}
MobilePassModalModule.ɵfac = function MobilePassModalModule_Factory(t) { return new (t || MobilePassModalModule)(); };
MobilePassModalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MobilePassModalModule });
MobilePassModalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            QRCodeModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MobilePassModalModule, { declarations: function () { return [MobilePassModalComponent]; }, imports: function () { return [CommonModule,
        QRCodeModule]; }, exports: function () { return [MobilePassModalComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MobilePassModalModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MobilePassModalComponent
                ],
                imports: [
                    CommonModule,
                    QRCodeModule
                ],
                exports: [
                    MobilePassModalComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MobilePassModalComponent, MobilePassModalModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-passes-mobile-pass-modal.js.map